import { Button, Dialog } from "@100mslive/react-ui";
import { DialogContent, DialogRow } from "../primitives/DialogContent";

import React from "react";
import { useHMSActions } from "@100mslive/react-sdk";

export const ScreenShareHintModal = ({ onClose }) => {
  const hmsActions = useHMSActions();
  return (
    <Dialog.Root defaultOpen onOpenChange={value => !value && onClose()}>
      <DialogContent title="Chỉ chia sẻ màn hình âm thanh">
        <img src="/share-audio.png" alt="Chỉ chia sẻ màn hình âm thanh" />
        <DialogRow justify="end">
          <Button
            variant="primary"
            onClick={() => {
              hmsActions
                .setScreenShareEnabled(true, {
                  audioOnly: true,
                  displaySurface: "browser",
                })
                .catch(console.error);
              onClose();
            }}
            data-testid="audio_screenshare_continue"
          >
            Tiếp tục
          </Button>
        </DialogRow>
      </DialogContent>
    </Dialog.Root>
  );
};
